module.exports = __webpack_public_path__ + "static/media/pier.1ccd8c38.jpg";